/* Little Big Supply: header chip sizing, floating-widget coordination, "open chat" buttons, the builder's
   "Email me this build" and GA4 forwarding of the site's own events (Oct 2026).
   Pairs with assets/lbs-mobile.css. Loaded from snippets/lbs-live.liquid. No dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;

  /* ---------- header: My Garage box = logo rectangle height ---------- */
  function syncChip() {
    var b = document.getElementById('LbsGarageBtn');
    var logo = document.querySelector('.header__heading-logo');
    if (!b || !logo) return;
    var h = logo.getBoundingClientRect().height;
    if (h > 12) b.style.setProperty('--lbs-chip-h', Math.round(h) + 'px');
  }

  /* ---------- kit builder: sticky bar height, so Chat can sit just above it ---------- */
  function syncBar() {
    var bar = document.querySelector('.lbsb__bar');
    if (bar && bar.offsetHeight) root.style.setProperty('--lbs-bar-h', bar.offsetHeight + 'px');
    var sticky = document.querySelector('.lbs-sticky-atc');
    if (sticky && sticky.offsetHeight) root.style.setProperty('--lbs-sticky-h', sticky.offsetHeight + 'px');
  }

  /* ---------- footer on phones: menu columns become tap-to-open rows ---------- */
  function footerAccordions() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    var blocks = document.querySelectorAll('.footer-block--menu');
    Array.prototype.forEach.call(blocks, function (block, i) {
      var head = block.querySelector('.footer-block__heading');
      var list = block.querySelector('.footer-block__details-content');
      if (!head || !list || block.classList.contains('lbs-acc')) return;
      if (!list.id) list.id = 'LbsFooterMenu-' + i;
      block.classList.add('lbs-acc');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-controls', list.id);
      head.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = block.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------- Phones: the sign-up teaser and Chat as one matched pair ----------
     Both 50px pills on the same baseline, 20px in from each corner: the teaser in volt (the offer),
     Chat in solid ink (the help). Styles go inside each widget's shadow root, re-checked on a light
     timer because both apps re-render on their own schedule. */
  var TEASER_CSS = '@media (max-width: 749px){' +
    '[class*="appEmbedRootTeaser"]{left:0 !important;right:auto !important;bottom:0 !important;top:auto !important;width:auto !important;' +
      'padding:0 0 20px 20px !important;justify-content:flex-start !important;align-items:flex-end !important}' +
    '[class*="appEmbedRootTeaser"] [class*="_container_"]{justify-content:start !important}' +
    '[data-testid="form-teaser"]{display:inline-flex !important;align-items:center !important;gap:10px !important;height:50px !important;min-height:50px !important;margin:0 !important;' +
      'padding:0 7px 0 20px !important;border-radius:25px !important;background:#e3fc02 !important;color:#1f1f21 !important;' +
      'box-shadow:0 6px 18px rgba(31,31,33,.28) !important;border:0 !important}' +
    '[data-testid="form-teaser"] h3{margin:0 !important;color:#1f1f21 !important;font:700 15px/1 Quantico, sans-serif !important;' +
      'text-transform:uppercase !important;letter-spacing:.06em !important;white-space:nowrap}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"]{display:grid !important;place-items:center;width:36px !important;height:36px !important;' +
      'border-radius:50%;background:rgba(31,31,33,.1);color:#1f1f21}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"] svg{width:10px;height:10px}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"] path{fill:currentColor}}';
  var CHAT_CSS = '.activator,.activator.activator--inverted-colors{background:#1f1f21 !important;color:#fff !important;border-radius:25px !important;' +
      'min-height:50px;box-shadow:0 6px 18px rgba(31,31,33,.28) !important;border:0 !important}' +
    '.activator__label{font-family:Quantico, sans-serif !important;font-weight:700 !important;font-size:15px !important;text-transform:uppercase;letter-spacing:.06em}' +
    '.activator__indicator--active{background:#e3fc02 !important}' +
    '.activator:focus-visible{outline:2px solid #e3fc02 !important;outline-offset:3px}';

  function addCss(rootNode, id, css) {
    if (!rootNode || rootNode.getElementById && rootNode.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = css;
    rootNode.appendChild(st);
  }
  function markForms() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return;
    addCss(host.shadowRoot, 'lbs-teaser-css', TEASER_CSS);
    var embed = host.shadowRoot.querySelector('#app-embed');
    var tease = !!embed && embed.getAttribute('data-current-step') === 'tease';
    if (host.classList.contains('lbs-is-teaser') !== tease) host.classList.toggle('lbs-is-teaser', tease);
  }
  function markChat() {
    var chat = document.querySelector('shopify-chat');
    var act = chat && findDeep(chat.shadowRoot, 'button.activator');
    if (act) addCss(act.getRootNode(), 'lbs-chat-css', CHAT_CSS);
  }
  function markFloaters() { markForms(); markChat(); }

  /* ---------- open the store chat from any [data-lbs-open-chat] button ---------- */
  function findDeep(node, sel) {
    if (!node) return null;
    var hit = node.querySelector(sel);
    if (hit) return hit;
    var all = node.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var deep = findDeep(all[i].shadowRoot, sel);
        if (deep) return deep;
      }
    }
    return null;
  }
  /* Opening is deferred a beat and goes through the chat's own show() method: on iPhone (Safari and
     Chrome are both WebKit) a click forwarded to the chat button inside the same tap could be undone by
     the tap itself. If the chat still isn't open after a retry, fall back to the link or the contact form. */
  function chatEl() { return document.querySelector('shopify-chat'); }
  function chatIsOpen() { var c = chatEl(); return !!c && c.hasAttribute('open'); }
  function showChat() {
    var c = chatEl();
    if (!c) return false;
    if (typeof c.show === 'function') { c.show(); return true; }
    var a = findDeep(c.shadowRoot, 'button.activator, [part~="activator"]');
    if (a) { a.click(); return true; }
    return false;
  }
  function openChat(fallback) {
    var settled = false;
    function fail() { if (settled) return; settled = true; if (fallback) fallback(); }
    function attempt(left) {
      if (settled) return;
      if (chatIsOpen()) { settled = true; return; }
      try { showChat(); } catch (err) { /* try again below */ }
      setTimeout(function () {
        if (chatIsOpen()) { settled = true; track('lbs_chat_open', {}); return; }
        if (left > 0) attempt(left - 1); else fail();
      }, 700);
    }
    document.body.classList.remove('lbs-scroll-down');
    if (window.customElements && !customElements.get('shopify-chat')) {
      if (!chatEl()) { fail(); return; }
      customElements.whenDefined('shopify-chat').then(function () { attempt(1); });
      setTimeout(function () { if (!customElements.get('shopify-chat')) fail(); }, 4000);
      return;
    }
    setTimeout(function () { attempt(1); }, 60);
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-lbs-open-chat]') : null;
    if (!t) return;
    var href = t.getAttribute('href');
    /* No chat on this page: a link just goes where it points. */
    if (!chatEl() && href && href.charAt(0) !== '#') return;
    e.preventDefault();
    track('lbs_chat_cta', { placement: t.getAttribute('data-lbs-open-chat') || 'button' });
    openChat(function () {
      if (href && href.charAt(0) !== '#') { window.location.href = href; return; }
      var form = document.getElementById('LbsContactForm') || document.getElementById('ContactForm') || document.querySelector('form[action*="/contact"]');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.href = '/pages/contact';
    });
  });

  /* Contact page: while the big "Start a chat" call-out is on screen, the floating Chat button steps aside. */
  function chatCtaWatch() {
    var cta = document.querySelector('.lbs-chatcta');
    if (!cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('lbs-chatcta-inview', entries[0].isIntersecting);
    }, { threshold: 0.25 }).observe(cta);
  }

  /* ---------- GA4: forward the site's own events (kit builder steps, adds, chat taps) ----------
     lbs-builder.js publishes "lbs:*" events to Shopify's customer events; these also go to GA4 so the
     funnel shows up in Google Analytics: lbs_builder_step (step, step_index, items, total), lbs_builder_add,
     lbs_builder_view, lbs_builder_email, lbs_chat_cta, lbs_chat_open. */
  var GA_ID = 'G-RDJZDXFMXF';
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ send_to: GA_ID }, params || {}));
    } catch (err) { /* analytics never breaks the page */ }
  }
  function gaBridge() {
    var tries = 0;
    (function hook() {
      var a = window.Shopify && window.Shopify.analytics;
      if (!a || typeof a.publish !== 'function') { if (++tries < 40) setTimeout(hook, 250); return; }
      if (a.publish.lbsWrapped) return;
      var orig = a.publish;
      var wrapped = function (name, payload) {
        var out = orig.apply(this, arguments);
        if (typeof name === 'string' && name.indexOf('lbs:') === 0) {
          var p = {};
          if (payload && typeof payload === 'object') {
            Object.keys(payload).forEach(function (k) {
              var v = payload[k];
              if (k === 'total' && typeof v === 'number') { p.value = Math.round(v) / 100; p.currency = 'USD'; }
              else if (v === null || typeof v !== 'object') p[k] = v;
            });
          }
          track(name.replace(':', '_'), p);
        }
        return out;
      };
      wrapped.lbsWrapped = true;
      try { a.publish = wrapped; } catch (err) { /* read-only: skip the bridge */ }
    })();
  }

  /* ---------- kit builder: "Email me this build" ----------
     Phones open the share sheet (Mail, Messages, AirDrop); desktops open a new email with the build link. */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try { return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' }); } catch (err) { return '$' + n.toFixed(2); }
  }
  function emailBuild() {
    var b = document.querySelector('lbs-builder');
    if (!b || typeof b.shareUrl !== 'function') return;
    function inject() {
      var row = b.querySelector('.lbsb-actions__row');
      if (!row || row.querySelector('[data-lbs-email-build]')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lbs-btn lbs-btn--ghost';
      btn.setAttribute('data-lbs-email-build', '');
      btn.textContent = 'Email me this build';
      row.insertBefore(btn, row.children[1] || null);
    }
    inject();
    new MutationObserver(inject).observe(b, { childList: true, subtree: true });
    track('lbs_builder_view', { page_path: location.pathname });
    b.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-lbs-email-build]') : null;
      if (!t) return;
      var url = b.shareUrl();
      var tot = typeof b.totals === 'function' ? b.totals() : { count: 0, total: 0 };
      var name = (document.querySelector('h1') || {}).textContent || 'My Little Big Supply build';
      name = name.replace(/\s+/g, ' ').trim();
      var subject = 'My build: ' + name;
      var body = 'Here is my build from Little Big Supply' + (tot.count ? ' (' + tot.count + (tot.count === 1 ? ' part, ' : ' parts, ') + money(tot.total) + ')' : '') +
        '.\n\nOpen it to pick up where I left off:\n' + url + '\n';
      track('lbs_builder_email', { items: tot.count, value: Math.round(tot.total) / 100, currency: 'USD', method: (isPhone() && navigator.share) ? 'share' : 'mailto' });
      if (isPhone() && navigator.share) {
        navigator.share({ title: subject, text: body.replace(url + '\n', ''), url: url }).catch(function () {});
      } else {
        window.location.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      }
    });
  }

  var isPhone = function () { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; };

  /* ---------- phones: floaters step aside while scrolling down ---------- */
  function scrollDirection() {
    var lastY = window.scrollY, ticking = false, body = document.body;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY;
        var nearEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 40;
        if (y > lastY + 8 && y > 240 && !nearEnd) body.classList.add('lbs-scroll-down');
        else if (y < lastY - 8 || y <= 240 || nearEnd) body.classList.remove('lbs-scroll-down');
        lastY = y;
      });
    }, { passive: true });
  }

  /* ---------- phones: "Read more" preview for very long blocks ---------- */
  function bgOf(el) {
    for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
      var c = getComputedStyle(e).backgroundColor;
      if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') return c;
    }
    return getComputedStyle(document.body).backgroundColor || '#fff';
  }
  function clamp(el, px, label) {
    if (!el || el.dataset.lbsClamp || !isPhone() || el.scrollHeight < px + 160) return false;
    el.dataset.lbsClamp = '1';
    el.style.setProperty('--lbs-clamp-h', px + 'px');
    el.style.setProperty('--lbs-clamp-bg', bgOf(el));
    el.classList.add('lbs-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lbs-clamp-btn';
    btn.textContent = label;
    btn.addEventListener('click', function () {
      el.classList.remove('lbs-clamp');
      btn.remove();
    });
    el.insertAdjacentElement('afterend', btn);
    return true;
  }
  function clampLongBlocks() {
    clamp(document.querySelector('.lbs-tabs > details:first-of-type > .lbs-tabs__body'), 360, 'Read the full overview');
    /* Judge.me renders late, so look for it for a while. */
    var tries = 0;
    var t = setInterval(function () {
      var w = document.querySelector('.jm-review-widget, .jdgm-rev-widg');
      if ((w && clamp(w, 900, 'Show more reviews')) || ++tries > 20) clearInterval(t);
    }, 800);
  }

  /* ---------- phones: In-house builds parts lists fold behind one row ---------- */
  function foldBuildParts() {
    if (!isPhone()) return;
    Array.prototype.forEach.call(document.querySelectorAll('.lbs-bld__shop'), function (box, i) {
      var list = box.querySelector('.lbs-recs__list');
      if (!list || box.classList.contains('lbs-fold')) return;
      var n = list.children.length;
      if (!list.id) list.id = 'LbsBuildParts-' + i;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lbs-fold__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', list.id);
      btn.textContent = 'Shop this build · ' + n + (n === 1 ? ' part' : ' parts');
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      box.classList.add('lbs-fold');
      box.insertBefore(btn, box.firstChild);
    });
  }

  /* ---------- phones: sticky total + Check out bar on the cart page ---------- */
  function cartBar() {
    var footer = document.getElementById('main-cart-footer');
    var real = document.getElementById('checkout');
    if (!footer || !real || !isPhone() || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'lbs-cartbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="lbs-cartbar__total"><span>Estimated total</span><strong></strong></div>' +
      '<button type="button" class="lbs-cartbar__btn" tabindex="-1">Check out</button>';
    document.body.appendChild(bar);
    var totalEl = bar.querySelector('strong');
    var btn = bar.querySelector('button');
    var realVisible = true;
    function sync() {
      var t = footer.querySelector('.totals__total-value');
      totalEl.textContent = t ? t.textContent.trim() : '';
      var cur = document.getElementById('checkout');
      var show = !realVisible && !!cur && !cur.disabled && !footer.classList.contains('is-empty');
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('lbs-cartbar-on', show);
      root.style.setProperty('--lbs-cartbar-h', bar.offsetHeight + 'px');
    }
    var io = new IntersectionObserver(function (entries) {
      realVisible = entries[0].isIntersecting;
      sync();
    });
    io.observe(real);
    new MutationObserver(function () {
      var cur = document.getElementById('checkout');
      if (cur && cur !== real) { io.unobserve(real); real = cur; io.observe(real); }
      sync();
    }).observe(footer, { subtree: true, childList: true, characterData: true });
    btn.addEventListener('click', function () {
      var cur = document.getElementById('checkout');
      if (cur && !cur.disabled) cur.click();
    });
    sync();
  }

  /* ---------- boot ---------- */
  function boot() {
    syncChip();
    syncBar();
    var logo = document.querySelector('.header__heading-logo');
    if (logo && !logo.complete) logo.addEventListener('load', syncChip);
    window.addEventListener('resize', function () { syncChip(); syncBar(); });
    var icons = document.querySelector('.header__icons');
    if (icons && window.MutationObserver) new MutationObserver(syncChip).observe(icons, { childList: true });
    var bar = document.querySelector('.lbsb__bar');
    var sticky = document.querySelector('.lbs-sticky-atc');
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncBar);
      if (bar) ro.observe(bar);
      if (sticky) ro.observe(sticky);
    }
    footerAccordions();
    scrollDirection();
    clampLongBlocks();
    foldBuildParts();
    cartBar();
    chatCtaWatch();
    gaBridge();
    if (window.customElements) customElements.whenDefined('lbs-builder').then(emailBuild);
    /* Style the sign-up teaser and Chat quickly while the page loads, then settle into a light timer. */
    markFloaters();
    var fast = setInterval(markFloaters, 150);
    setTimeout(function () { clearInterval(fast); setInterval(markFloaters, 700); }, 6000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
